import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalPageRoutingModule } from './modal-routing.module';

import { ModalPage } from './modal.page';
import { SharedModule } from 'src/app/shared/shared.module';
@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule, //Share module import
    // ModalPageRoutingModule,
    
  ],
  declarations: [ModalPage]
})
export class ModalPageModule {}
